// Layer 1 data: named cross-area correlation pairs (emails.A7 #324).

import type { CorrelationPair } from '@/versions/v1/schema/correlation-pair';

export const CORRELATION_PAIRS: readonly CorrelationPair[] = [
  {
    id: 'pair-zn-reag-pb-ph',
    primaryRole: 'reagent-cuso4-rate',
    correlatedRole: 'pb-rougher-ph',
    lagMinutes: 90,
    direction: 'opposite',
    sampleWindowHours: 8,
    provenance:
      '[syn] Zn-circuit activator dose against Pb rougher pH — seeded pair for cross-area nudge at demo cursor',
  },
];
